import Vue from 'vue';
import vueQr from 'vue-qr';

Vue.use(vueQr);
